import { CircleAlertIcon } from "lucide-react";

import Tooltip from "./Tooltip";
import classNames from "@/helpers/classNames";

type Props = {
  error: string;
  iconClassNames?: string;
};

const InputErrorTooltip = (props: Props) => {
  return (
    <Tooltip content={props.error}>
      <div>
        <CircleAlertIcon
          className={classNames(`text-red-500`, props.iconClassNames)}
          aria-hidden="true"
        />
      </div>
    </Tooltip>
  );
};

export default InputErrorTooltip;
